import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReframe"><Path d="M17.6494 4.00293L16.8994 5.30176L12.75 2.90527V11.5781L20.5 16.2949V11.5381H22V18.0615L16.3506 21.3232L15.6006 20.0244L19.7783 17.6113L11.999 12.877L4.21973 17.6104L8.39941 20.0244L7.64941 21.3232L2 18.0615V11.5381H3.5V16.2939L11.25 11.5781V2.90527L7.10059 5.30176L6.35059 4.00293L12 0.741211L17.6494 4.00293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReframe;
